import React from 'react'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import Heroimg2 from '../components/Heroimg2'
import Form from '../components/Form'
import { Helmet } from 'react-helmet-async'



const Contact = () => {
  return (
    <>
    <Helmet>
      <title>Contact Me</title>
      <meta name='description' content={"'Reach out to me for business and jobs am willing to start effectively today!'"}/>
      <link rel='canonical' href='' />
    </Helmet>

    <div>
      <Navbar/>
      <Heroimg2
      heading='CONTACT.'
      text='For more information:'/>
      <Form />
      <Footer/>
    </div>
    </>
  )
}

export default Contact